<div class="flex-col gap-2 justify-center items-center">
  <p class="font-roboto-500 text-16 text-center">
    {{ getStatsName() | translate }}
  </p>
  <div class="flex pb-2">
    <div class="flex-col flex-grow">
      <p class="w-full font-roboto-600 text-14">
        {{ getHomeStats() }}
      </p>
      <div
        class="flex justify-end w-full h-1.5 bg-[#f5f5f5] rounded-5 overflow-hidden"
      >
        <div
          class="bg-[#172c41] h-full rounded-5"
          [style.width.%]="getHomeStatsPercentage()"
        ></div>
      </div>
    </div>
    <div class="flex-col flex-grow">
      <p class="w-full font-roboto-600 text-14 text-end">
        {{ getAwayStats() }}
      </p>
      <div class="w-full h-1.5 bg-[#f5f5f5] rounded-5 overflow-hidden">
        <div
          class="bg-[#e20e17] h-full rounded-5"
          [style.width.%]="getAwayStatsPercentage()"
        ></div>
      </div>
    </div>
  </div>
</div>
